__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@maui-mf/root@1.11.1";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@maui-mf/analytics-datadog-rum", "2.2.1", () => (Promise.all([__webpack_require__.e(44), __webpack_require__.e(522)]).then(() => (() => (__webpack_require__(8044))))));
			register("@maui-mf/common-auth", "2.11.2", () => (Promise.all([__webpack_require__.e(357), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(2964))))));
			register("@maui-mf/common-history", "1.0.1", () => (__webpack_require__.e(744).then(() => (() => (__webpack_require__(6744))))));
			register("@maui-mf/common-react", "2.7.2", () => (Promise.all([__webpack_require__.e(927), __webpack_require__.e(407), __webpack_require__.e(139)]).then(() => (() => (__webpack_require__(6139))))));
			register("@maui-mf/env", "2.1.1", () => (__webpack_require__.e(749).then(() => (() => (__webpack_require__(4179))))));
			register("@maui-mf/experiments", "1.3.0", () => (Promise.all([__webpack_require__.e(927), __webpack_require__.e(576), __webpack_require__.e(476)]).then(() => (() => (__webpack_require__(476))))));
			register("@maui-mf/splitio-react", "0.3.2", () => (Promise.all([__webpack_require__.e(927), __webpack_require__.e(421), __webpack_require__.e(576), __webpack_require__.e(741)]).then(() => (() => (__webpack_require__(3741))))));
			register("@maui-mf/splitio", "0.2.2", () => (Promise.all([__webpack_require__.e(99), __webpack_require__.e(407), __webpack_require__.e(435)]).then(() => (() => (__webpack_require__(2435))))));
			register("@maui/dashboards", "1.2.24", () => (Promise.all([__webpack_require__.e(455), __webpack_require__.e(927), __webpack_require__.e(634), __webpack_require__.e(822)]).then(() => (() => (__webpack_require__(2455))))));
			register("@maui/icon-data", "1.14.1", () => (__webpack_require__.e(81).then(() => (() => (__webpack_require__(4081))))));
			register("@maui/react-query", "1.2.1", () => (Promise.all([__webpack_require__.e(397), __webpack_require__.e(927), __webpack_require__.e(960)]).then(() => (() => (__webpack_require__(4397))))));
			register("@splitsoftware/splitio-react", "1.8.1", () => (Promise.all([__webpack_require__.e(99), __webpack_require__.e(6), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(6))))));
			register("@tanstack/react-query", "4.29.3", () => (Promise.all([__webpack_require__.e(286), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(1286))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(980).then(() => (() => (__webpack_require__(3980))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(927)]).then(() => (() => (__webpack_require__(8316))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(671), __webpack_require__.e(927), __webpack_require__.e(314)]).then(() => (() => (__webpack_require__(8671))))));
			register("react", "17.0.2", () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(2784))))));
			register("single-spa", "5.9.3", () => (__webpack_require__.e(309).then(() => (() => (__webpack_require__(309))))));
			register("single-spa", "5.9.4", () => (__webpack_require__.e(780).then(() => (() => (__webpack_require__(4780))))));
			initExternal(5431);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};